module.exports = __webpack_public_path__ + "img/xiaomi12timage3mobile.ea8cb114.png";